/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Validation_Secret_KeyInputs */



/**
* | output |
* | --- |
* | "Every secret needs a name" |
*
* @param {Partner_Connectors_Validation_Secret_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_validation_secret_key = /** @type {((inputs?: Partner_Connectors_Validation_Secret_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Validation_Secret_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jedes Secret braucht einen Namen")
	return /** @type {LocalizedString} */ ("Every secret needs a name")
});